export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no"},{"name":"description","content":"Leeski Meet video chat with new people online ✔️ 1v1 chats ✔️ 1V1 video calls ✔️ find your next date ✔️make new friends."},{"name":"keywords","content":"Live Chat, meet new people, 1v1 video calls, online chatrooms, free video chat, webcam chat, random video chat, private video chat, leeski, Leeski"},{"property":"og:title","content":"Leeski - Meet new people and start wonderful video chat"},{"property":"og:description","content":"Leeski Meet video chat with new people online ✔️1V1 video calls ✔️1v1 chats ✔️ make new friends ✔️ find your next date"},{"property":"og:locale","content":"en"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Leeski"},{"property":"og:url","content":""},{"property":"og:image","content":"https://leeski-client.leeski.net/logo.png"},{"property":"og:image:width","content":"180"},{"property":"og:image:height","content":"180"},{"property":"og:image:type","content":"image/png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"build-version","content":"1.1.4.1"}],"link":[],"style":[{"textContent":"html { background-color: transparent }"}],"script":[{"src":"/cdn/js/lib-flexible@0.3.2.js"},{"type":"application/ld+json","children":"{\"@context\" : \"https://schema.org\", \"@type\" : \"WebSite\", \"name\" : \"Leeski\", \"url\" : \"\"}"},{"src":"/cdn/js/AgoraRTC_N-4.19.3.js","defer":true},{"src":"/cdn/js/svgaplayerweb@2.3.2.min.js","defer":true}],"noscript":[],"title":"Leeski - Meet new people and start wonderful video chat"}

export const appKeepalive = {"include":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false